import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header'

const ModalUploadHousesForm = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;
  const [businessLocations, setBusinessLocations] = useState([]);
  const [companyID] = useState(1); // Replace with actual companyID
  const [location] = useState(''); // Replace with actual location if needed
  const [uploadMethod, setUploadMethod] = useState('');
  const [houseDetails, setHouseDetails] = useState({
    houseNumber: '',
    rentalsPaymentInterval: '',
    rentalPrice: '',
    rentalNumberOfRooms: '',
    rentalStatus: '',
    businessLocationID: '',
  });

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", companyID);
    formData.append("location", location);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, [companyID, location]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHouseDetails({ ...houseDetails, [name]: value });
  };
/*
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, {
        ...houseDetails,
        companyID,
        businessLocationID: location,
        apiType: 'registerHouses',
      });
      if (response.data === 'Successful') {
        alert('Successfully Uploaded');
        setHouseDetails({
          houseNumber: '',
          rentalsPaymentInterval: '',
          rentalPrice: '',
          rentalNumberOfRooms: '',
          rentalStatus: '',
          businessLocationID: '',
        });
      } else {
        alert(`Failed to Upload: ${response.data}`);
      }
    } catch (error) {
      alert('Error submitting form. Please try again.');
      console.error('Error submitting form', error);
    }
  };
*/
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Create a new FormData object
  const formData = new FormData();
  
  // Append each house detail to the FormData object
  formData.append('houseNumber', houseDetails.houseNumber);
  formData.append('rentalsPaymentInterval', houseDetails.rentalsPaymentInterval);
  formData.append('rentalPrice', houseDetails.rentalPrice);
  formData.append('rentalNumberOfRooms', houseDetails.rentalNumberOfRooms);
  formData.append('rentalStatus', houseDetails.rentalStatus);
  formData.append('businessLocationID', houseDetails.businessLocationID);
  formData.append('companyID', companyID);
  formData.append('apiType', 'registerHouses');

  try {
      // Send the formData using Axios
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      });

      if (response.data === 'Successful') {
          alert('Successfully Uploaded');
          setHouseDetails({
              houseNumber: '',
              rentalsPaymentInterval: '',
              rentalPrice: '',
              rentalNumberOfRooms: '',
              rentalStatus: '',
              businessLocationID: '',
          });
      } else {
          alert(`Failed to Upload: ${response.data}`);
      }
  } catch (error) {
      alert('Internet Error submitting form. Please try again or change Your Internet Source.');
      //console.error('Error submitting form', error);
  }
};


  const handleFileUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert(response.data);
    } catch (error) {
      alert('Error uploading file. Please try again.');
      //console.error('Error uploading file', error);
    }
  };

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadHousesForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Houses</p>
        
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                <select
                  className="custom-select d-block w-100"
                  id="uploadMethodHouses"
                  name="uploadMethodHouses"
                  value={uploadMethod}
                  onChange={(e) => setUploadMethod(e.target.value)}
                >
                  <option value="">Choose Upload Method..</option>
                  <option value="Single Form">Single Form</option>
                  <option value="Upload Excel File">Upload Excel File</option>
                </select>
              </div>
            </div>
            {uploadMethod === 'Upload Excel File' && (
              <div className="row" id="uploadExcelFileHouses">
                <form name="fileUploadFormHouses" id="fileUploadFormHouses" encType="multipart/form-data" onSubmit={handleFileUpload}>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <select className="custom-select d-block w-100" id="business_locationIDHousesExcel" name="business_locationIDHousesExcel" required>
                      <option value="">Choose Business Location..</option>
                      {businessLocations.map((location) => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>
                          {location.businessLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <label htmlFor="form22">Select Excel File</label>
                    <br />
                    <div className="md-form md-outline">
                      <input type="file" id="excelHouses" name="excelHouses" className="form-control form-control-sm" />
                      <input type="hidden" id="companyID" name="companyID" value={companyID} />
                      <input type="hidden" id="apiType" name="apiType" value="registerHousesExcel" />
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button className="btn btn-success" id="registerHousesExcel">Upload <i className="fas fa-pen-alt ml-1"></i></button>
                  </div>
                </form>
              </div>
            )}
            {uploadMethod === 'Single Form' && (
              <div className="row" id="singleFormHouses">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select
                    className="custom-select d-block w-100"
                    id="business_locationIDHouses"
                    name="business_locationIDHouses"
                    value={houseDetails.businessLocationID}
                    onChange={handleInputChange}
                  >
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map((location) => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="houseNumber" name="houseNumber" className="form-control form-control-md" value={houseDetails.houseNumber} onChange={handleInputChange} />
                    <label htmlFor="form22">House Number</label>
                  </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="rentalsPaymentInterval" name="rentalsPaymentInterval" className="form-control form-control-md" value={houseDetails.rentalsPaymentInterval} onChange={handleInputChange} />
                    <label htmlFor="form23">Rentals Payment Interval</label>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="rentalPrice" name="rentalPrice" className="form-control form-control-md" value={houseDetails.rentalPrice} onChange={handleInputChange} />
                    <label htmlFor="form22">Rental Price</label>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="rentalNumberOfRooms" name="rentalNumberOfRooms" className="form-control form-control-md" value={houseDetails.rentalNumberOfRooms} onChange={handleInputChange} />
                    <label htmlFor="form23">Number Of Rooms</label>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="rentalStatus" name="rentalStatus" className="form-control form-control-md" value={houseDetails.rentalStatus} onChange={handleInputChange} />
                    <label htmlFor="form23">Status</label>
                  </div>
                </div>
                <div className="text-center mt-0">
                  <button className="btn btn-success"  onClick={handleSubmit}>
                    Register <i className="fas fa-pen-alt ml-1"></i>
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadHousesForm;
